import {createRef} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import AtomVideoPlayer from '@s-ui/react-atom-video-player'

import {BASE_CLASS, INTERSECTION_OBSERVER_CONFIGURATION} from '../../../config.js'
import {getAutoPlayValue, isExternalVideo} from '../../../utils.js'

const Player = ({
  autoPlay,
  currentSlide,
  displayVideoControls,
  isVideoPlaying,
  index,
  onVideoClick,
  onVideoPlay,
  url,
  videoApiRef = createRef(),
  timeOffset,
  title,
  fallback = null
}) => {
  const emitVideoPlayEvent = () => {
    if ((autoPlay || isVideoPlaying) && index === currentSlide) onVideoPlay()
  }

  const avoidOnViewportAutoPlay = displayVideoControls

  const classNames = cx(`${BASE_CLASS}-videoOverlay`, {
    'has-controls': displayVideoControls
  })
  return (
    <>
      {(displayVideoControls === false || isExternalVideo(url)) && (
        <div
          className={classNames}
          onClick={event => {
            event.preventDefault()
            onVideoClick()
          }}
        />
      )}
      <AtomVideoPlayer
        key={`videoPlayer-${url}-${autoPlay}`}
        autoPlay={getAutoPlayValue({autoPlay, isVideoPlaying, avoidOnViewportAutoPlay})}
        controls={displayVideoControls}
        intersectionObserverConfiguration={INTERSECTION_OBSERVER_CONFIGURATION}
        muted
        ref={videoApiRef}
        src={url}
        timeOffset={timeOffset}
        title={title}
        playsInline={true}
        fallbackWhileNotOnViewport={true}
        fallbackComponent={fallback}
        onLoadVideo={emitVideoPlayEvent}
      />
    </>
  )
}

Player.propTypes = {
  autoPlay: PropTypes.bool,
  displayVideoControls: PropTypes.bool,
  isVideoPlaying: PropTypes.bool,
  onVideoClick: PropTypes.func,
  onVideoPlay: PropTypes.func,
  url: PropTypes.string,
  videoApiRef: PropTypes.object,
  timeOffset: PropTypes.number,
  currentSlide: PropTypes.number,
  index: PropTypes.number,
  title: PropTypes.string,
  fallback: PropTypes.node
}

export default Player
